import { Divider, Grid, Paper, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import AmbiguousGroupCards from 'src/connected-assets/matching/components/AmbiguousGroupCards';
import SuggestionReviewTable from 'src/connected-assets/matching/components/SuggestionReviewTable';
import MatchComparison from 'src/connected-assets/matching/components/MatchComparison';
import MatchReasonExplainer from 'src/connected-assets/matching/components/MatchReasonExplainer';
import {
  AMBIGUOUS_MATCHES,
  HIGH_CONFIDENCE_EMPTY,
  HIGH_CONFIDENCE_FEW,
  HIGH_CONFIDENCE_MANY,
  HIGH_CONFIDENCE_MULTI_REASON,
  HIGH_CONFIDENCE_WITH_RESOLVED,
} from './fixtures';

const noop = () => {};

export default function MatchingSandbox() {
  return (
    <Stack gap="xl">
      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        MatchReasonExplainer
      </Text>
      <Grid>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchReasonExplainer suggestion={HIGH_CONFIDENCE_MANY[0]} />
          </Paper>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchReasonExplainer suggestion={HIGH_CONFIDENCE_MANY[3]} />
          </Paper>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchReasonExplainer suggestion={HIGH_CONFIDENCE_MANY[4]} />
          </Paper>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchReasonExplainer suggestion={HIGH_CONFIDENCE_MULTI_REASON[0]} />
          </Paper>
        </Grid.Col>
      </Grid>

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        MatchComparison
      </Text>
      <Grid>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchComparison suggestion={HIGH_CONFIDENCE_MANY[0]} />
          </Paper>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchComparison suggestion={HIGH_CONFIDENCE_MULTI_REASON[0]} />
          </Paper>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchComparison suggestion={HIGH_CONFIDENCE_MANY[7]} />
          </Paper>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <MatchComparison suggestion={HIGH_CONFIDENCE_MANY[2]} />
          </Paper>
        </Grid.Col>
      </Grid>

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        High Confidence: Many matches
      </Text>
      <SuggestionReviewTable
        suggestions={HIGH_CONFIDENCE_MANY}
        headerAction={null}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        High Confidence: Few matches
      </Text>
      <SuggestionReviewTable
        suggestions={HIGH_CONFIDENCE_FEW}
        headerAction={null}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        High Confidence: With resolved (confirmed + rejected) rows
      </Text>
      <SuggestionReviewTable
        suggestions={HIGH_CONFIDENCE_WITH_RESOLVED}
        headerAction={null}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        High Confidence: Multi-reason matches
      </Text>
      <SuggestionReviewTable
        suggestions={HIGH_CONFIDENCE_MULTI_REASON}
        headerAction={null}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        High Confidence: Confirming (loading state)
      </Text>
      <SuggestionReviewTable
        suggestions={HIGH_CONFIDENCE_MANY}
        headerAction={null}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        High Confidence: Empty
      </Text>
      <SuggestionReviewTable
        suggestions={HIGH_CONFIDENCE_EMPTY}
        headerAction={null}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        Ambiguous: Accordion cards (fan-out, fan-in, complex)
      </Text>
      <Text size="sm" c="dimmed">
        Three groups: (1) one feed matched two assets, (2) two feeds matched one asset, (3) complex
        connected component with two feeds and two assets linked through a shared asset.
      </Text>
      <AmbiguousGroupCards
        suggestions={AMBIGUOUS_MATCHES}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
        onRejectGroup={noop}
      />

      <Divider />

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        Ambiguous: Empty
      </Text>
      <AmbiguousGroupCards
        suggestions={[]}
        onConfirm={noop}
        onReject={noop}
        onUnlink={noop}
        onReopen={noop}
        onRejectGroup={noop}
      />
    </Stack>
  );
}
